// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/**
 * 获取员工合同列表
 */
export async function getEmployeeContractList(
  params: OA.EmployeeContractListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.EmployeeContractListData>>(
    '/api/v1/profiles/contracts/',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

/**
 * 获取单个员工合同详情
 */
export async function getEmployeeContract(
  contractId: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.EmployeeContract>>(
    `/api/v1/profiles/contracts/${contractId}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 创建员工合同
 */
export async function createEmployeeContract(
  params: OA.CreateEmployeeContractParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.EmployeeContract>>('/api/v1/profiles/contracts/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/**
 * 更新员工合同
 */
export async function updateEmployeeContract(
  contractId: number,
  params: OA.UpdateEmployeeContractParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.EmployeeContract>>(
    `/api/v1/profiles/contracts/${contractId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      data: params,
      ...(options || {}),
    },
  );
}

/**
 * 删除员工合同
 */
export async function deleteEmployeeContract(
  contractId: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`/api/v1/profiles/contracts/${contractId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/**
 * 获取合同续期提醒
 */
export async function getContractRenewalReminders(
  days: number = 90,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.RenewalRemindersData>>(
    '/api/v1/profiles/contracts/renewal-reminders',
    {
      method: 'GET',
      params: { days },
      ...(options || {}),
    },
  );
}

